import React, { useRef, useState, useEffect } from 'react'
import { KnovaText } from '../../BasicUIComponents/KnovaText'
import { KnovaImage } from '../../BasicUIComponents/KnovaImage'
import AssessmentComponents from '../AssessmentComponents'
import { findDefaultValueForComponent } from '../../utils/SmartCanvasUtils'

function LayoutImageAssmnt(props) {
  const {
    isPractice,
    Completed,
    isActive,
    layoutData,
    layoutId,
    layoutType,
    themeProperties,
    isSideMenu,
    controlsList,
    isFollowTheFlow,
    priorityActive,
    isClassroom,
    isAudioPlaying
  } = props
  const {
    InkJson,
    replayRectangles,
    strokeColor,
    strokeReplayStarted,
    sketchType,
    strokeWidth,
    currentSpeed,
    getCurrentRectangleData,
    getStrokeReplayFinished,
    getReplyStatus,
    isReplaying
  } = props //Replay rectangles variables
  const {
    handleValueChange,
    onPriorityChange,
    handleSucAndFailFeedback,
    onToastTrigger,
    onVideoControlChange
  } = props
  const [textData, setTextData] = useState({})
  const [assesmentBlockData, setAssesmentBlockData] = useState({})
  const [componentDefaultValue, setComponentDefaultValue] = useState()
  const [assesmentBlockDataArray, setAssesmentBlockDataArray] = useState([])
  const [currentSelectedDropdown, setcurrentSelectedDropdown] = useState(-1)
  const [isOutsideClick, setIsOutsideClick] = useState(false)
  const [componentPositionOne, setComponentPositionOne] = useState({})
  const [componentPositionTwo, setComponentPositionTwo] = useState({})
  const [componentPositionThree, setComponentPositionThree] = useState({})

  useEffect(() => {
    let textDataCopy = layoutData.filter((e) => e.PluginId === 'SCTextArea')
    setTextData(textDataCopy[0])
    //Find component data with that position
    let assesmentBlockDataCopy = layoutData.filter(
      (e) => e.PluginId !== 'SCTextArea'
    )
    let overallComponentArrayCopy =
      assesmentBlockDataCopy.concat(replayRectangles)
    let position1 = overallComponentArrayCopy.filter((e) => e.BoxPosition === 1)
    setComponentPositionOne(position1[0])
    let position2 = overallComponentArrayCopy.filter((e) => e.BoxPosition === 2)
    setComponentPositionTwo(position2[0])
    let position3 = overallComponentArrayCopy.filter((e) => e.BoxPosition === 3)
    if (position3 && layoutId === 11) {
      setComponentPositionThree(position3[0])
    }

    setAssesmentBlockDataArray(assesmentBlockDataCopy)
  }, [])

  useEffect(() => {
    if (Object.keys(assesmentBlockData).length > 0) {
      const defltVal = controlsList.find(
        (c) => c.CtlId === assesmentBlockData.ControlID
      )
      const embedDefaultValue = defltVal
        ? {
            ...defltVal,
            CtlValue: defltVal.CtlValue.Answer
          }
        : undefined
      setComponentDefaultValue(embedDefaultValue)
    }
  }, [controlsList])

  function renderAssesmentBlock(assesmentComponentData) {
    let componentDefaultValue = {}
    if (assesmentComponentData && assesmentComponentData !== null) {
      componentDefaultValue = findDefaultValueForComponent(
        assesmentComponentData,
        controlsList
      )
    }

    return (
      <AssessmentComponents
        isPractice={isPractice}
        Completed={Completed}
        isActive={isActive}
        themeProperties={themeProperties}
        assesmentBlockData={assesmentComponentData}
        isSideMenu={isSideMenu}
        componentDefaultValue={componentDefaultValue}
        isOutsideClick={isOutsideClick}
        isFollowTheFlow={isFollowTheFlow}
        priorityActive={priorityActive}
        getCurrentSelectedOption={getCurrentSelectedOption}
        handleValueChange={handleValueChange}
        onPriorityChange={onPriorityChange}
        handleSucAndFailFeedback={handleSucAndFailFeedback}
        isReplayMode={true}
        //Replay rectangle variables
        InkJson={InkJson}
        strokeColor={strokeColor}
        strokeReplayStarted={strokeReplayStarted}
        sketchType={sketchType}
        strokeWidth={strokeWidth}
        currentSpeed={currentSpeed}
        getCurrentRectangleData={getCurrentRectangleData}
        getReplyStatus={getReplyStatus}
        getStrokeReplayFinished={getStrokeReplayFinished}
        onToastTrigger={onToastTrigger}
        onVideoControlChange={onVideoControlChange}
        isClassroom={isClassroom}
        isAudioPlaying={isAudioPlaying}
        isReplaying={isReplaying}
      />
    )
  }

  function getCurrentSelectedOption(currentSelectedDropdown) {
    setcurrentSelectedDropdown(currentSelectedDropdown)
  }

  function renderImage(assesmentFullData) {
    return <KnovaImage imgSource={assesmentFullData.Url} objectFit='contain' />
  }

  function renderImageWithAssessment() {
    let assesmentFullData = componentPositionOne
    let assesmentHalfTopData = componentPositionTwo
    return (
      <div
        className='component-block-cont'
        style={{ paddingBottom: isSideMenu ? '2px' : '20px' }}
      >
        <div className='half-full-cont1'>
          {layoutType === 'A'
            ? renderImage(assesmentFullData)
            : renderAssesmentBlock(assesmentHalfTopData)}
        </div>
        <div className='half-full-cont1'>
          {layoutType === 'A'
            ? renderAssesmentBlock(assesmentHalfTopData)
            : renderImage(assesmentFullData)}
        </div>
      </div>
    )
  }

  function renderLayoutFull(assesmentFullData) {
    if (layoutType === 'C') {
      return (
        <div className='half-full-cont1'>
          {renderAssesmentBlock(assesmentFullData)}
        </div>
      )
    } else {
      return (
        <div className='half-full-cont1'>{renderImage(assesmentFullData)}</div>
      )
    }
  }

  function renderLayoutHalf(assesmentHalfTopData, assesmentHalfBottomData) {
    return (
      <div className='half-full-cont2'>
        <div className='quater-half-cont1'>
          {renderAssesmentBlock(assesmentHalfTopData)}
        </div>
        <div className='quater-half-cont2'>
          {renderAssesmentBlock(assesmentHalfBottomData)}
        </div>
      </div>
    )
  }

  function renderImageWith2Assessment() {
    let assesmentFullData = componentPositionOne
    let assesmentHalfTopData = componentPositionTwo
    let assesmentHalfBottomData = componentPositionThree
    return (
      <div className='component-block-cont'>
        {layoutType === 'A'
          ? renderLayoutFull(assesmentFullData)
          : layoutType === 'C'
          ? renderLayoutFull(assesmentHalfTopData)
          : renderLayoutHalf(assesmentHalfTopData, assesmentHalfBottomData)}
        {layoutType === 'A'
          ? renderLayoutHalf(assesmentHalfTopData, assesmentHalfBottomData)
          : layoutType === 'C'
          ? renderLayoutFull(assesmentHalfBottomData)
          : renderLayoutFull(assesmentFullData)}
      </div>
    )
  }

  if (layoutData.length > 0) {
    return (
      <div
        className='layout-main-cont'
        onClick={() => {
          if (currentSelectedDropdown > -1) {
            setIsOutsideClick(true)
            setTimeout(() => {
              setIsOutsideClick(false)
            }, 1000)
          }
        }}
      >
        <div className='layout-ques-cont-10' style={{ padding: '2% 5% 0 5%' }}>
          {layoutType === 'C' && (
            <div className='layout-ques-image-cont'>
              {renderImage(componentPositionOne)}
            </div>
          )}
          <KnovaText
            text={
              textData && Object.keys(textData).length > 0 ? textData.Value : ''
            }
            textColor={themeProperties.themeColors.onBackground}
            textFontSize={isSideMenu ? '5px' : '20px'}
            textFontFamily={themeProperties.themeFont.bodyFont}
            textFontWeight='400'
            textHeight='130%'
            alignValue={layoutType === 'C' ? 'center' : 'start'}
          />
        </div>
        <div
          className='layout-block-cont-q3a'
          style={{ padding: isSideMenu ? '0 3% 3% 3%' : '0 5% 0 5%' }}
        >
          {assesmentBlockDataArray.length > 0 &&
            (layoutId === 10
              ? renderImageWithAssessment()
              : renderImageWith2Assessment())}
        </div>
      </div>
    )
  } else {
    return null
  }
}
export default LayoutImageAssmnt
